import script from "./BoostedVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoostedVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./BoostedVouchersPage.vue?vue&type=style&index=0&id=65020939&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65020939"]])

export default __exports__